import React from 'react';
import EmergencySpokePage from './EmergencySpokePage';

// Spoke: Zahnnotfall im Urlaub (Touristen-Guide) — ohne Warnbox.
const EmergencyTouristsPage: React.FC = () => (
  <EmergencySpokePage
    routeKey="emergency-tourists"
    namespace="tourists"
    medicalCondition="Dental emergency"
  />
);

export default EmergencyTouristsPage;
